'use client';

import Newsletter from '@/components/Newsletter';
import StoreConfig from '@/config';
import { WebsiteEnv } from '@/constants/website-env';
import { useFooter } from '@/hooks/Footer/useFooter';
import clsx from 'clsx';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import PaymentImages from '../payment-images';
import { PageViewTracker } from '../shape/page-view-trigger';
import FooterMenu from './footerMenu';

const Footer = () => {
  const { handleSwitchCountry } = useFooter();

  const pathname = usePathname();

  const isCartPage = pathname === '/cart';

  const currentCountryCode = StoreConfig.current_country_code;

  const availableCountries = StoreConfig.available_countries;

  const currentCountry = useMemo(() => {
    return availableCountries.find(temp => temp.code === currentCountryCode);
  }, [availableCountries, currentCountryCode]);

  const countries = availableCountries.map(country => {
    if (country.hideInOptions) return null;

    return (
      <span
        onClick={() => {
          handleSwitchCountry(country.code);
        }}
        key={country.code}
        className='cursor-pointer'
      >
        <img
          className='mr-[10px] h-auto w-7'
          src={country.icon}
          alt=''
        />
      </span>
    );
  });

  return (
    <footer className={clsx(isCartPage && 'hidden', 'lg_block')}>
      <PageViewTracker />
      {/* <ShapeTrigger /> */}
      {/* <Shape /> */}
      <ul className='grid grid-cols-2 gap-[3px] lg_flex  lg_gap-x-[5px]'>
        {configs.map(({ svg, title, svgWrapperClassName, className }, i, arr) => {
          return (
            <li
              key={i}
              className={clsx(
                (i === 0 || i === arr.length - 1) && 'lg_flex lg_flex-1 lg_items-center ',
                i === arr.length - 1 && 'lg_justify-start',
                i === 0 && 'lg_justify-end',
                'h-[114px] lg_h-[160px] lg_basis-[340px]',
                className,
              )}
            >
              <div className={clsx(' h-full lg_basis-[340px] ')}>
                <div className={clsx(svgWrapperClassName, 'flex justify-center')}>{svg}</div>
                <p
                  className={clsx(
                    'mt-2.5 text-center text-[15px] font-medium leading-[22px] lg_font-normal',
                    'text-#403732 lg_text-[17px] lg_leading-6',
                  )}
                >
                  {title}
                </p>
              </div>
            </li>
          );
        })}
      </ul>

      <div className='bg-f8f3ef lg_mt-[5px]'>
        <div className='mx-auto max-w-site justify-between gap-x-5 px-4 lg_flex lg_items-start lg_px-0 lg_py-20'>
          <div className='py-[30px] lg_py-0'>
            <p className='font-Shango text-[26px] leading-8 text-#403732'>GET 5% OFF AND MORE!</p>
            <Newsletter />
            <div className='mt-[30px] flex items-center justify-center gap-x-9 lg_justify-start'>
              {socialLinkConfigs.map(({ svg, href, text }, i) => {
                return (
                  <Link
                    href={href}
                    aria-label={text}
                    key={i}
                  >
                    <span className='hidden'>{text}</span>
                    {svg}
                  </Link>
                );
              })}
            </div>
            <div className='mt-[24px] text-[17px] leading-[1.4] text-[#403732] lg_mt-[60px]'>SHOPPING FROM</div>
            <div className='mt-[22px] flex flex-col  justify-start  text-[15px] leading-[1.4] text-[#403732]'>
              <p className='flex w-full items-center md_w-auto'>
                You&apos;re in{' '}
                <img
                  className='ml-2.5 h-auto w-7'
                  src={currentCountry.icon}
                  alt={currentCountry.name}
                />
              </p>
              <p className='mt-2.5 flex w-full flex-col items-start gap-x-4 gap-y-2.5 lg_mt-2.5 lg_flex-row lg_items-center'>
                <span>Some of our international sites:</span>
                <span className='flex items-center'>{countries}</span>
              </p>
            </div>
          </div>
          <FooterMenu />
        </div>
        <div className='mx-auto flex max-w-site flex-col gap-y-2.5 px-2.5 py-[30px] lg_flex-row lg_items-center lg_justify-between lg_px-0 lg_py-5'>
          <PaymentImages />

          <div className='text-center text-[13px] leading-[18px] text-[#6d6b6b] lg_leading-4'>
            © 2009-{year} AW.Bridal Ltd., All Right Reserved.&nbsp;
            <br className='lg_hidden' />
            <Link
              href='/privacy-policy'
              className='lg_hover_text-80583F lg_hover_underline'
            >
              Privacy Policy
            </Link>
            &nbsp;|&nbsp;
            <Link
              href='/terms-and-conditions'
              className='lg_hover_text-80583F lg_hover_underline'
            >
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

const year = new Date().getFullYear();

const socialLinkConfigs = [
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='10'
        height='21'
        fill='none'
        viewBox='0 0 10 21'
      >
        <path
          fill='#80583F'
          d='M9.714 10.93H6.206v9.444H2.563V10.93H0V7.557h2.563V4.589C2.563 2.295 4.047.137 7.42.137c1.35 0 2.429.135 2.429.135L9.714 3.51H7.555c-1.214 0-1.349.54-1.349 1.484v2.428h3.643z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M9.714 10.93H6.206v9.444H2.563V10.93H0V7.557h2.563V4.589C2.563 2.295 4.047.137 7.42.137c1.35 0 2.429.135 2.429.135L9.714 3.51H7.555c-1.214 0-1.349.54-1.349 1.484v2.428h3.643z'
        />
      </svg>
    ),
    href: 'https://www.facebook.com/aw.bridal/',
    text: "AW.Bridal's Facebook Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='18'
        height='21'
        fill='none'
        viewBox='0 0 18 21'
      >
        <path
          fill='#80583F'
          d='M4.22 19.326c0-.81 0-1.89.27-2.834s1.62-6.61 1.62-6.61-.405-.81-.405-1.889c0-1.754 1.079-3.103 2.293-3.103 1.08 0 1.619.81 1.619 1.889 0 1.08-.675 2.833-1.08 4.317-.27 1.214.675 2.294 1.89 2.294 2.293 0 3.912-2.969 3.912-6.476 0-2.699-1.754-4.722-4.992-4.722-3.642 0-5.936 2.698-5.936 5.801 0 1.08.27 1.754.81 2.428.27.27.27.405.134.675 0 .27-.135.81-.27.944-.134.27-.27.405-.674.27C1.657 11.636.848 9.747.848 7.723.848 4.35 3.816.168 9.482.168c4.587 0 7.69 3.373 7.69 7.015 0 4.723-2.698 8.365-6.61 8.365-1.35 0-2.564-.674-2.969-1.484 0 0-.674 2.833-.81 3.373-.269.944-.809 1.889-1.213 2.563.135-.135-1.08 1.215-1.35-.674'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M4.22 19.326c0-.81 0-1.89.27-2.834s1.62-6.61 1.62-6.61-.405-.81-.405-1.889c0-1.754 1.079-3.103 2.293-3.103 1.08 0 1.619.81 1.619 1.889 0 1.08-.675 2.833-1.08 4.317-.27 1.214.675 2.294 1.89 2.294 2.293 0 3.912-2.969 3.912-6.476 0-2.699-1.754-4.722-4.992-4.722-3.642 0-5.936 2.698-5.936 5.801 0 1.08.27 1.754.81 2.428.27.27.27.405.134.675 0 .27-.135.81-.27.944-.134.27-.27.405-.674.27C1.657 11.636.848 9.747.848 7.723.848 4.35 3.816.168 9.482.168c4.587 0 7.69 3.373 7.69 7.015 0 4.723-2.698 8.365-6.61 8.365-1.35 0-2.564-.674-2.969-1.484 0 0-.674 2.833-.81 3.373-.269.944-.809 1.889-1.213 2.563.135-.135-1.08 1.215-1.35-.674'
        />
      </svg>
    ),
    href: 'https://www.pinterest.com/aw_bridal/',
    text: "AW.Bridal's Pinterest Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='18'
        fill='none'
        viewBox='0 0 24 18'
      >
        <path
          fill='#80583F'
          fillRule='evenodd'
          d='M19.06.754H4.412C2.1.754.172 2.628.172 5.305v7.764c0 2.543 1.927 4.685 4.24 4.685h14.52c2.313 0 4.24-2.142 4.24-4.685V5.305c0-2.543-1.799-4.551-4.112-4.551M9.295 13.069V5.573L15.59 9.32z'
          clipRule='evenodd'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          fillRule='evenodd'
          d='M19.06.754H4.412C2.1.754.172 2.628.172 5.305v7.764c0 2.543 1.927 4.685 4.24 4.685h14.52c2.313 0 4.24-2.142 4.24-4.685V5.305c0-2.543-1.799-4.551-4.112-4.551M9.295 13.069V5.573L15.59 9.32z'
          clipRule='evenodd'
        />
      </svg>
    ),
    href: 'https://www.youtube.com/@aw.bridal/videos',
    text: "AW.Bridal's Youtube Page",
  },
  {
    svg: (
      <svg
        width='18'
        height='21'
        viewBox='0 0 18 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.27397 0.283661C10.3625 0.26709 11.443 0.275375 12.5232 0.26709C12.5896 1.53963 13.0466 2.83727 13.9774 3.73575C14.9081 4.65909 16.2211 5.0831 17.501 5.22469V8.57662C16.3043 8.53495 15.0995 8.28541 14.0107 7.76977C13.5369 7.55362 13.0965 7.27898 12.6644 6.9963C12.6561 9.42515 12.6727 11.854 12.6478 14.2743C12.5814 15.4389 12.1991 16.5949 11.526 17.5514C10.4375 19.1486 8.5509 20.1881 6.61491 20.2215C5.42659 20.288 4.23826 19.9637 3.22425 19.3647C1.5456 18.3748 0.365553 16.5616 0.191236 14.6152C0.174681 14.1992 0.16616 13.7835 0.182959 13.3758C0.332686 11.7955 1.1137 10.2817 2.32686 9.25018C3.7063 8.05245 5.63426 7.47856 7.43756 7.81948C7.45411 9.0506 7.40445 10.2815 7.40445 11.5126C6.5818 11.2465 5.6177 11.3213 4.89487 11.8204C4.37143 12.1615 3.9724 12.6855 3.76473 13.2762C3.59017 13.7004 3.64008 14.1661 3.64836 14.6152C3.84775 15.9794 5.16073 17.1272 6.55672 17.0024C7.48747 16.9941 8.37658 16.4534 8.85863 15.6633C9.01639 15.3887 9.19095 15.106 9.19948 14.7817C9.28249 13.2927 9.24938 11.8121 9.25766 10.3234C9.2657 6.9712 9.2489 3.62755 9.27397 0.283661Z'
          fill='#80583F'
        />
      </svg>
    ),
    href: 'https://www.tiktok.com/@awbridal_official?lang=zh-Hant-TW',
    text: "AW.Bridal's Tiktok Page",
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='21'
        height='21'
        fill='none'
        viewBox='0 0 21 21'
      >
        <path
          fill='#80583F'
          d='M10.3 4.992c-2.763 0-5 2.294-5 5.127s2.237 5.127 5 5.127 4.998-2.294 4.998-5.127-2.236-5.127-4.999-5.127m0 8.635c-1.842 0-3.29-1.484-3.29-3.373S8.459 6.88 10.3 6.88c1.84 0 3.288 1.484 3.288 3.373s-1.447 3.373-3.289 3.373'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M10.3 4.992c-2.763 0-5 2.294-5 5.127s2.237 5.127 5 5.127 4.998-2.294 4.998-5.127-2.236-5.127-4.999-5.127m0 8.635c-1.842 0-3.29-1.484-3.29-3.373S8.459 6.88 10.3 6.88c1.84 0 3.288 1.484 3.288 3.373s-1.447 3.373-3.289 3.373'
        />
        <path
          fill='#80583F'
          d='M14.378 0H5.96C2.803 0 .172 2.698.172 5.936v8.635c0 3.238 2.63 5.936 5.788 5.936h8.418c3.157 0 5.788-2.698 5.788-5.936V5.936c0-3.238-2.63-5.936-5.788-5.936m3.947 14.3c0 2.294-1.842 4.183-4.078 4.183H6.354c-2.236 0-4.077-1.889-4.077-4.182V6.34c0-2.294 1.841-4.182 4.077-4.182h7.893c2.236 0 4.078 1.888 4.078 4.182z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M14.378 0H5.96C2.803 0 .172 2.698.172 5.936v8.635c0 3.238 2.63 5.936 5.788 5.936h8.418c3.157 0 5.788-2.698 5.788-5.936V5.936c0-3.238-2.63-5.936-5.788-5.936m3.947 14.3c0 2.294-1.842 4.183-4.078 4.183H6.354c-2.236 0-4.077-1.889-4.077-4.182V6.34c0-2.294 1.841-4.182 4.077-4.182h7.893c2.236 0 4.078 1.888 4.078 4.182z'
        />
        <path
          fill='#80583F'
          d='M15.43 3.645c-.658 0-1.184.54-1.184 1.214s.526 1.214 1.184 1.214 1.184-.54 1.184-1.214c0-.675-.526-1.214-1.184-1.214'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M15.43 3.645c-.658 0-1.184.54-1.184 1.214s.526 1.214 1.184 1.214 1.184-.54 1.184-1.214c0-.675-.526-1.214-1.184-1.214'
        />
      </svg>
    ),
    href: 'https://www.instagram.com/aw.bridal/',
    text: "AW.Bridal's Instagram Page",
  },
];

const configs = [
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='35'
        height='40'
        fill='none'
        viewBox='0 0 35 40'
        className='h-auto w-6 lg_w-[33px]'
      >
        <g
          fill='#8C6239'
          clipPath='url(#clip0_12170_29486)'
        >
          <path d='M30.637 40H4.365a3.416 3.416 0 01-3.416-3.41V10.61h33.104v25.98A3.416 3.416 0 0130.637 40zM2.872 12.523v24.06c0 .825.672 1.49 1.493 1.49H30.63c.826 0 1.493-.671 1.493-1.49v-24.06H2.872z' />
          <path d='M34.053 12.523H.949V3.41A3.416 3.416 0 014.365 0H30.63a3.416 3.416 0 013.415 3.41v9.113h.007zm-31.181-1.92H32.13V3.411c0-.826-.673-1.491-1.493-1.491H4.365c-.82 0-1.493.672-1.493 1.49v7.193z' />
          <path d='M28.425 10.605H6.535v1.92h21.89v-1.92z' />
          <path d='M6.631 35.035H6.6c-.327-.006-.807-.128-1.25-.665-.941-1.14-.217-2.33.257-3.11.301-.493.615-1.005.615-1.472 0-.492-.16-.697-.448-1.062-.366-.46-.866-1.088-.866-2.252 0-1.165.5-1.792.866-2.253.288-.365.448-.563.448-1.062 0-.5-.16-.698-.448-1.062-.366-.461-.866-1.088-.866-2.253 0-1.164.5-1.792.866-2.252.288-.365.448-.563.448-1.056 0-.493-.16-.698-.448-1.062-.366-.461-.866-1.088-.866-2.253 0-1.164.5-1.791.866-2.252l.288-.365.468-.006h22.357l.288.364c.366.461.866 1.088.866 2.253s-.5 1.792-.866 2.252c-.288.365-.448.563-.448 1.062 0 .493.16.698.448 1.063.366.46.866 1.088.866 2.252 0 1.165-.5 1.792-.866 2.253-.288.364-.448.563-.448 1.062 0 .493.16.697.448 1.062.366.46.866 1.088.866 2.253 0 1.107-.526 1.804-.91 2.31-.372.492-.488.665-.398 1.055.154.704.462 1.184.756 1.651.43.679 1.09 1.709.116 2.886-.442.538-.923.66-1.25.666h-.032c-.788 0-1.326-.602-1.8-1.133-.212-.237-.66-.736-.84-.736-.18 0-.27.077-.609.512-.384.506-.974 1.26-2.127 1.26-1.154 0-1.743-.76-2.128-1.26-.34-.435-.429-.512-.608-.512-.18 0-.27.077-.61.512-.384.506-.973 1.26-2.127 1.26-1.153 0-1.742-.76-2.127-1.26-.333-.435-.43-.512-.602-.512-.18 0-.27.077-.61.512-.383.506-.973 1.26-2.127 1.26-1.16 0-1.742-.76-2.133-1.26-.34-.435-.43-.512-.61-.512-.179 0-.62.5-.839.736-.467.525-1.006 1.126-1.794 1.126zm13.585-3.788c1.16 0 1.743.762 2.127 1.26.334.436.43.513.61.513.179 0 .268-.077.608-.512.384-.506.974-1.26 2.128-1.26.993 0 1.691.729 2.204 1.298-.007-.013-.02-.026-.026-.038-.333-.519-.782-1.235-1.012-2.272-.276-1.267.314-2.048.743-2.617.34-.454.52-.71.52-1.152 0-.493-.161-.697-.45-1.062-.365-.46-.865-1.088-.865-2.253 0-1.164.5-1.791.866-2.252.288-.365.448-.563.448-1.062 0-.493-.16-.698-.448-1.063-.366-.46-.866-1.087-.866-2.252 0-1.165.5-1.792.866-2.252.288-.365.448-.563.448-1.063 0-.307-.064-.505-.18-.69H7.017c-.122.191-.186.39-.186.703 0 .493.16.698.448 1.063.366.46.866 1.087.866 2.252 0 1.165-.5 1.792-.866 2.252-.288.365-.448.564-.448 1.063 0 .492.16.697.448 1.062.366.46.866 1.088.866 2.252 0 1.165-.5 1.792-.866 2.253-.288.364-.448.563-.448 1.062 0 .499.16.697.448 1.062.366.46.866 1.088.866 2.253 0 1.004-.5 1.817-.898 2.47-.044.076-.102.16-.153.256.512-.564 1.198-1.261 2.172-1.261 1.16 0 1.743.761 2.134 1.26.34.436.43.512.609.512s.269-.076.608-.511c.385-.506.974-1.261 2.128-1.261 1.153 0 1.743.761 2.127 1.26.333.436.43.512.603.512.179 0 .269-.076.608-.511.391-.512.974-1.274 2.134-1.274zM29.145 4.04H16.367v1.919h12.778v-1.92zM29.143 7.469h-6.39v1.92h6.39v-1.92z' />
        </g>
        <defs>
          <clipPath id='clip0_12170_29486'>
            <path
              fill='#fff'
              d='M0 0H33.103V40H0z'
              transform='translate(.95)'
            />
          </clipPath>
        </defs>
      </svg>
    ),
    title: '5 FREE SWATCHES',
    svgWrapperClassName: clsx('lg_px-[5px] lg_py-1.5'),
    className: clsx('bg-f8f3ef pt-[31px] lg_pt-[26px]'),
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='69'
        height='36'
        fill='none'
        viewBox='0 0 69 36'
        className='h-auto w-[48px] lg_w-[67px]'
      >
        <path
          fill='#80583F'
          d='M67.354 7.868V5l-1.23.31c-6.17 1.558-12.432 3.203-16.849 4.374.316-.52.48-1.052.48-1.618C49.75 3.099 37.466.5 25.33.5 13.19.5.902 3.099.902 8.066c0 .131.02.256.033.381H.902V26.23l.066.171c.131.336 3.28 8.25 15.989 8.862 3.088.145 5.704.237 8.102.237 7.774 0 13.255-.908 24.998-3.605 3.135-.717 11.113-2.678 17.408-5.349l.631-.263-.742-18.415zM43.11 11.31c-.302.106-.61.204-.933.296-.013.007-.02.007-.033.013-.335.1-.683.198-1.045.29l-.315.079c-.256.066-.52.131-.782.19-.138.034-.276.06-.414.093l-.75.158c-.15.032-.301.059-.453.092-.256.052-.519.098-.782.145l-.46.078-.88.139c-.132.02-.263.04-.401.059-.427.059-.867.118-1.308.177h-.013c-.447.053-.907.106-1.367.152-.144.013-.289.026-.427.04-.322.032-.644.058-.973.085l-.525.04c-.303.019-.605.045-.907.065-.184.013-.375.02-.565.033-.303.02-.605.033-.914.046-.184.006-.374.02-.558.026-.335.013-.664.02-1 .033-.164.007-.321.007-.486.013-.492 0-.992.007-1.491.007-.5 0-1-.007-1.499-.013-.164 0-.322-.007-.486-.013a49.584 49.584 0 01-1.557-.06 40.274 40.274 0 01-.914-.046c-.19-.013-.374-.02-.565-.033-.302-.02-.611-.04-.913-.065l-.526-.04c-.329-.026-.65-.06-.973-.085l-.427-.04c-.46-.046-.92-.098-1.367-.151h-.013a39.12 39.12 0 01-1.308-.178l-.4-.059-.881-.138-.46-.08c-.263-.045-.526-.091-.782-.144-.151-.026-.302-.06-.453-.092a74.42 74.42 0 01-.75-.158c-.138-.033-.276-.06-.414-.092-.27-.06-.525-.125-.782-.19-.105-.027-.217-.053-.315-.08a33.71 33.71 0 01-1.045-.29c-.007 0-.02-.006-.026-.006-.322-.098-.631-.197-.933-.296-.099-.033-.184-.066-.276-.098-.152-.06-.296-.112-.447-.171.138-.053.282-.106.427-.158.098-.033.197-.073.296-.106.289-.098.591-.197.9-.29l.059-.019c.335-.099.683-.197 1.038-.29l.322-.078c.257-.066.513-.125.776-.191.138-.033.282-.06.42-.092.244-.053.493-.105.743-.158.151-.033.302-.06.453-.092.257-.046.52-.099.782-.145l.46-.079.874-.138.408-.06c.42-.058.854-.118 1.288-.17.013 0 .02 0 .033-.007.447-.053.907-.105 1.367-.151l.427-.04c.322-.033.644-.059.972-.085l.526-.04c.302-.02.605-.046.913-.065.184-.014.375-.02.566-.033.302-.02.61-.033.913-.046.184-.007.375-.02.559-.027.335-.013.663-.02.999-.033.164-.006.322-.006.486-.013.5-.006.999-.013 1.498-.013.5 0 .999.007 1.498.013.165 0 .322.007.487.013a49.073 49.073 0 011.557.06c.31.013.611.026.914.046.19.013.374.02.565.033.309.02.611.039.913.065l.526.04c.329.026.65.059.973.085l.427.04c.46.046.92.098 1.367.151.013 0 .02 0 .032.007.434.052.868.112 1.288.17l.408.06.874.138c.158.026.309.053.46.079.263.046.526.092.782.145.151.026.302.059.453.092.25.053.5.105.743.158.138.033.282.059.42.092.263.06.52.125.776.19l.322.08c.355.092.703.19 1.038.29l.06.019c.308.092.61.19.9.29.105.032.197.072.296.105.144.052.289.105.427.158-.145.052-.296.111-.447.164-.086.033-.178.072-.27.105zM25.33 2.474c13.912 0 22.455 3.256 22.455 5.592 0 .552-.572 1.217-1.578 1.848-.059-.026-.118-.052-.177-.085-.125-.06-.263-.125-.394-.184a8.523 8.523 0 00-.493-.21 8.482 8.482 0 00-.434-.172c-.177-.066-.348-.138-.532-.204-.151-.052-.309-.112-.473-.164-.19-.066-.381-.125-.572-.191a47.633 47.633 0 00-.506-.158c-.197-.06-.407-.118-.611-.178-.178-.046-.355-.098-.539-.144-.21-.053-.427-.112-.65-.165-.191-.046-.382-.092-.572-.131-.224-.053-.454-.1-.684-.145-.197-.04-.394-.086-.598-.125a23.015 23.015 0 00-.716-.132c-.204-.04-.414-.072-.624-.112l-.75-.118-.644-.099c-.256-.04-.519-.072-.782-.105-.216-.026-.44-.06-.663-.085a34.28 34.28 0 00-.815-.093c-.224-.026-.447-.052-.67-.072a403.46 403.46 0 00-.855-.079l-.677-.06a38.51 38.51 0 00-.9-.065c-.223-.013-.447-.033-.67-.046-.316-.02-.638-.033-.96-.046-.21-.013-.427-.02-.637-.033-.355-.013-.716-.02-1.071-.033a15.45 15.45 0 00-.552-.013c-.546-.013-1.098-.013-1.65-.013-.552 0-1.104.007-1.65.013-.183.007-.367.013-.551.013-.362.007-.716.02-1.071.033-.217.007-.427.02-.638.033-.322.013-.644.026-.96.046-.223.013-.446.033-.67.046-.302.02-.598.04-.893.066l-.677.06-.854.078c-.224.02-.447.046-.67.072-.277.033-.546.06-.816.093-.223.026-.44.059-.663.085-.263.033-.526.072-.782.105-.217.033-.434.066-.644.1l-.75.117c-.21.033-.413.073-.624.112-.243.046-.48.086-.716.132-.204.04-.4.079-.598.125-.23.046-.46.099-.684.145-.19.046-.38.092-.571.131-.217.053-.434.105-.65.165-.185.046-.362.098-.54.144-.203.06-.414.119-.61.178-.172.053-.343.105-.507.158-.197.06-.388.125-.572.19-.157.053-.315.113-.473.165a9.987 9.987 0 00-.532.204c-.145.06-.29.112-.434.171-.17.073-.328.145-.493.21-.131.06-.262.12-.394.185a2.18 2.18 0 00-.177.085c-1.025-.631-1.597-1.296-1.597-1.848 0-2.336 8.543-5.592 22.455-5.592zM49.61 29.967c-15.141 3.474-19.708 3.934-32.562 3.322-10.56-.506-13.695-6.394-14.175-7.44v-14.54l1.078.592.473.264.02-.014c.643.323 1.36.625 2.155.908v4.83H8.57v-4.211c2.156.598 4.686 1.079 7.446 1.407v9.954h1.971v-9.736c1.551.144 3.168.236 4.817.29v3.552h1.972v-3.513c.184 0 .361.006.545.006 1.453 0 2.879-.04 4.272-.112v9.869h1.971v-10a66.144 66.144 0 004.712-.52v3.822h1.971v-4.15c2.038-.376 3.884-.837 5.468-1.37l.006.027c.027-.007.585-.158 1.558-.415v10.296h1.971V12.264c1.269-.335 2.826-.75 4.58-1.217v5.02h1.972v-5.54c1.479-.388 3.063-.802 4.705-1.23v10.717h1.972V8.79c1.61-.414 3.253-.835 4.902-1.256l.684 17.454c-6.046 2.474-13.472 4.296-16.455 4.98z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M67.354 7.868V5l-1.23.31c-6.17 1.558-12.432 3.203-16.849 4.374.316-.52.48-1.052.48-1.618C49.75 3.099 37.466.5 25.33.5 13.19.5.902 3.099.902 8.066c0 .131.02.256.033.381H.902V26.23l.066.171c.131.336 3.28 8.25 15.989 8.862 3.088.145 5.704.237 8.102.237 7.774 0 13.255-.908 24.998-3.605 3.135-.717 11.113-2.678 17.408-5.349l.631-.263-.742-18.415zM43.11 11.31c-.302.106-.61.204-.933.296-.013.007-.02.007-.033.013-.335.1-.683.198-1.045.29l-.315.079c-.256.066-.52.131-.782.19-.138.034-.276.06-.414.093l-.75.158c-.15.032-.301.059-.453.092-.256.052-.519.098-.782.145l-.46.078-.88.139c-.132.02-.263.04-.401.059-.427.059-.867.118-1.308.177h-.013c-.447.053-.907.106-1.367.152-.144.013-.289.026-.427.04-.322.032-.644.058-.973.085l-.525.04c-.303.019-.605.045-.907.065-.184.013-.375.02-.565.033-.303.02-.605.033-.914.046-.184.006-.374.02-.558.026-.335.013-.664.02-1 .033-.164.007-.321.007-.486.013-.492 0-.992.007-1.491.007-.5 0-1-.007-1.499-.013-.164 0-.322-.007-.486-.013a49.584 49.584 0 01-1.557-.06 40.274 40.274 0 01-.914-.046c-.19-.013-.374-.02-.565-.033-.302-.02-.611-.04-.913-.065l-.526-.04c-.329-.026-.65-.06-.973-.085l-.427-.04c-.46-.046-.92-.098-1.367-.151h-.013a39.12 39.12 0 01-1.308-.178l-.4-.059-.881-.138-.46-.08c-.263-.045-.526-.091-.782-.144-.151-.026-.302-.06-.453-.092a74.42 74.42 0 01-.75-.158c-.138-.033-.276-.06-.414-.092-.27-.06-.525-.125-.782-.19-.105-.027-.217-.053-.315-.08a33.71 33.71 0 01-1.045-.29c-.007 0-.02-.006-.026-.006-.322-.098-.631-.197-.933-.296-.099-.033-.184-.066-.276-.098-.152-.06-.296-.112-.447-.171.138-.053.282-.106.427-.158.098-.033.197-.073.296-.106.289-.098.591-.197.9-.29l.059-.019c.335-.099.683-.197 1.038-.29l.322-.078c.257-.066.513-.125.776-.191.138-.033.282-.06.42-.092.244-.053.493-.105.743-.158.151-.033.302-.06.453-.092.257-.046.52-.099.782-.145l.46-.079.874-.138.408-.06c.42-.058.854-.118 1.288-.17.013 0 .02 0 .033-.007.447-.053.907-.105 1.367-.151l.427-.04c.322-.033.644-.059.972-.085l.526-.04c.302-.02.605-.046.913-.065.184-.014.375-.02.566-.033.302-.02.61-.033.913-.046.184-.007.375-.02.559-.027.335-.013.663-.02.999-.033.164-.006.322-.006.486-.013.5-.006.999-.013 1.498-.013.5 0 .999.007 1.498.013.165 0 .322.007.487.013a49.073 49.073 0 011.557.06c.31.013.611.026.914.046.19.013.374.02.565.033.309.02.611.039.913.065l.526.04c.329.026.65.059.973.085l.427.04c.46.046.92.098 1.367.151.013 0 .02 0 .032.007.434.052.868.112 1.288.17l.408.06.874.138c.158.026.309.053.46.079.263.046.526.092.782.145.151.026.302.059.453.092.25.053.5.105.743.158.138.033.282.059.42.092.263.06.52.125.776.19l.322.08c.355.092.703.19 1.038.29l.06.019c.308.092.61.19.9.29.105.032.197.072.296.105.144.052.289.105.427.158-.145.052-.296.111-.447.164-.086.033-.178.072-.27.105zM25.33 2.474c13.912 0 22.455 3.256 22.455 5.592 0 .552-.572 1.217-1.578 1.848-.059-.026-.118-.052-.177-.085-.125-.06-.263-.125-.394-.184a8.523 8.523 0 00-.493-.21 8.482 8.482 0 00-.434-.172c-.177-.066-.348-.138-.532-.204-.151-.052-.309-.112-.473-.164-.19-.066-.381-.125-.572-.191a47.633 47.633 0 00-.506-.158c-.197-.06-.407-.118-.611-.178-.178-.046-.355-.098-.539-.144-.21-.053-.427-.112-.65-.165-.191-.046-.382-.092-.572-.131-.224-.053-.454-.1-.684-.145-.197-.04-.394-.086-.598-.125a23.015 23.015 0 00-.716-.132c-.204-.04-.414-.072-.624-.112l-.75-.118-.644-.099c-.256-.04-.519-.072-.782-.105-.216-.026-.44-.06-.663-.085a34.28 34.28 0 00-.815-.093c-.224-.026-.447-.052-.67-.072a403.46 403.46 0 00-.855-.079l-.677-.06a38.51 38.51 0 00-.9-.065c-.223-.013-.447-.033-.67-.046-.316-.02-.638-.033-.96-.046-.21-.013-.427-.02-.637-.033-.355-.013-.716-.02-1.071-.033a15.45 15.45 0 00-.552-.013c-.546-.013-1.098-.013-1.65-.013-.552 0-1.104.007-1.65.013-.183.007-.367.013-.551.013-.362.007-.716.02-1.071.033-.217.007-.427.02-.638.033-.322.013-.644.026-.96.046-.223.013-.446.033-.67.046-.302.02-.598.04-.893.066l-.677.06-.854.078c-.224.02-.447.046-.67.072-.277.033-.546.06-.816.093-.223.026-.44.059-.663.085-.263.033-.526.072-.782.105-.217.033-.434.066-.644.1l-.75.117c-.21.033-.413.073-.624.112-.243.046-.48.086-.716.132-.204.04-.4.079-.598.125-.23.046-.46.099-.684.145-.19.046-.38.092-.571.131-.217.053-.434.105-.65.165-.185.046-.362.098-.54.144-.203.06-.414.119-.61.178-.172.053-.343.105-.507.158-.197.06-.388.125-.572.19-.157.053-.315.113-.473.165a9.987 9.987 0 00-.532.204c-.145.06-.29.112-.434.171-.17.073-.328.145-.493.21-.131.06-.262.12-.394.185a2.18 2.18 0 00-.177.085c-1.025-.631-1.597-1.296-1.597-1.848 0-2.336 8.543-5.592 22.455-5.592zM49.61 29.967c-15.141 3.474-19.708 3.934-32.562 3.322-10.56-.506-13.695-6.394-14.175-7.44v-14.54l1.078.592.473.264.02-.014c.643.323 1.36.625 2.155.908v4.83H8.57v-4.211c2.156.598 4.686 1.079 7.446 1.407v9.954h1.971v-9.736c1.551.144 3.168.236 4.817.29v3.552h1.972v-3.513c.184 0 .361.006.545.006 1.453 0 2.879-.04 4.272-.112v9.869h1.971v-10a66.144 66.144 0 004.712-.52v3.822h1.971v-4.15c2.038-.376 3.884-.837 5.468-1.37l.006.027c.027-.007.585-.158 1.558-.415v10.296h1.971V12.264c1.269-.335 2.826-.75 4.58-1.217v5.02h1.972v-5.54c1.479-.388 3.063-.802 4.705-1.23v10.717h1.972V8.79c1.61-.414 3.253-.835 4.902-1.256l.684 17.454c-6.046 2.474-13.472 4.296-16.455 4.98z'
        />
      </svg>
    ),
    title: WebsiteEnv.isUnitedKingdom ? 'FREE CUSTOMISATION' : 'FREE CUSTOMIZATION',
    svgWrapperClassName: clsx('lg_px-3 lg_py-2.5'),
    className: clsx('bg-[#F2ECE6] pt-[31px] lg_pt-[26px]'),
  },
  {
    svg: (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='57'
        height='40'
        fill='none'
        viewBox='0 0 57 40'
        className='h-auto w-[44px] lg_w-[55px]'
      >
        <path
          fill='#80583F'
          d='M1.488 39.5a.908.908 0 01-.918-.9c0-.498.41-.9.918-.9h54.024c.508 0 .918.402.918.9s-.41.9-.918.9H1.488zm12.598-2.872c-3.828 0-5.45-1.723-6.133-3.906l-.176-.765-.02-.039c-.038-.115-.077-.23-.077-.344v-.02l-.04-.191c-.136-.919-.175-1.895-.175-2.795V10.015c.176-4.69 2.441-6.873 5.684-7.562l.917-.134v-.92c.02-.497.43-.899.938-.899s.918.402.918.9v.823l26.23-.019c1.915.191 4.376 1.302 4.493 3.982.293 3.638.117 5.61-.332 9.21l-.098.823c-.352 1.914-1.465 3.12-3.32 3.37-.04 0-.078.019-.137.019h-.918v4.69h.469c1.543.058 3.008.058 4.18.632 1.289.632 2.03 1.838 2.539 3.772.02.057.02.115.02.172.136 2.547-.099 4.576-1.27 5.935-1.192 1.398-3.125 1.838-5.645 1.82H14.086zm28.086-1.8c2.383 0 3.594-.44 4.238-1.187.157-.172.274-.363.391-.612l.195-.594-.175.038H9.809l.254.613c.566.977 1.62 1.742 4.023 1.742h28.086zm5.059-4.04l.039-.938-.04-.785-.155-.516c-.41-1.264-.899-1.762-1.426-2.01-.723-.345-1.68-.384-3.399-.441H25.023c-2.206.057-3.535-1.168-3.613-3.389v-6.012c.04-3.101 2.09-4.575 5.371-4.441h7.715c1.367.172 2.461.746 2.871 2.01 0 .019.02.057.02.076l.84 3.485h4.433l.684-.192c.645-.325 1.055-1.014 1.152-2.374v-.057c.117-.88.196-1.666.274-2.393l.117-1.513H9.301v17.27c0 .46 0 .919.02 1.34l.077.785h37.403c.117 0 .254.02.352.076l.078.02zm-31.407-4.384c-1.738 0-3.125-1.378-3.125-3.063 0-1.685 1.406-3.063 3.125-3.063s3.125 1.378 3.125 3.063c0 1.685-1.406 3.063-3.125 3.063zm0-1.8c.723 0 1.29-.574 1.29-1.263 0-.709-.587-1.264-1.29-1.264-.722 0-1.289.575-1.289 1.264 0 .69.567 1.264 1.29 1.264zm24.18-.306v-1.761h-1.308a.908.908 0 01-.918-.9c0-.498.41-.9.918-.9h1.308v-1.13h-2.5c-.43 0-.8-.287-.879-.689l-.996-4.116-.176-.306c-.273-.307-.879-.556-2.246-.46H26.762c-2.559-.096-3.496.785-3.535 2.661v5.974c.039 1.206.546 1.666 1.796 1.627h14.981zM6 19.703a.908.908 0 01-.918-.9V14.17c0-.498.41-.9.918-.9s.918.402.918.9v4.633c0 .498-.41.9-.918.9zm9.824-.306c-1.738 0-3.125-1.379-3.125-3.063 0-1.685 1.406-3.064 3.125-3.064s3.125 1.379 3.125 3.064c0 1.684-1.406 3.063-3.125 3.063zm0-1.8c.723 0 1.29-.574 1.29-1.263 0-.709-.587-1.283-1.29-1.283a1.28 1.28 0 00-1.289 1.283c0 .689.567 1.263 1.29 1.263zM44.926 9.5l.02-.843a37.922 37.922 0 00-.137-2.374c-.059-1.55-1.856-2.374-3.34-2.297h-.059l-26.64.038-1.133.153c-2.207.44-3.75 1.685-4.2 4.538l-.078.785h35.567zM15.004 8.235a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c0 .517-.41.919-.918.919zm4.121 0a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c-.02.517-.43.919-.918.919zm4.102 0a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c0 .517-.41.919-.918.919zm4.12 0a.908.908 0 01-.917-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c-.02.517-.43.919-.918.919z'
        />
        <path
          fill='#000'
          fillOpacity='0.2'
          d='M1.488 39.5a.908.908 0 01-.918-.9c0-.498.41-.9.918-.9h54.024c.508 0 .918.402.918.9s-.41.9-.918.9H1.488zm12.598-2.872c-3.828 0-5.45-1.723-6.133-3.906l-.176-.765-.02-.039c-.038-.115-.077-.23-.077-.344v-.02l-.04-.191c-.136-.919-.175-1.895-.175-2.795V10.015c.176-4.69 2.441-6.873 5.684-7.562l.917-.134v-.92c.02-.497.43-.899.938-.899s.918.402.918.9v.823l26.23-.019c1.915.191 4.376 1.302 4.493 3.982.293 3.638.117 5.61-.332 9.21l-.098.823c-.352 1.914-1.465 3.12-3.32 3.37-.04 0-.078.019-.137.019h-.918v4.69h.469c1.543.058 3.008.058 4.18.632 1.289.632 2.03 1.838 2.539 3.772.02.057.02.115.02.172.136 2.547-.099 4.576-1.27 5.935-1.192 1.398-3.125 1.838-5.645 1.82H14.086zm28.086-1.8c2.383 0 3.594-.44 4.238-1.187.157-.172.274-.363.391-.612l.195-.594-.175.038H9.809l.254.613c.566.977 1.62 1.742 4.023 1.742h28.086zm5.059-4.04l.039-.938-.04-.785-.155-.516c-.41-1.264-.899-1.762-1.426-2.01-.723-.345-1.68-.384-3.399-.441H25.023c-2.206.057-3.535-1.168-3.613-3.389v-6.012c.04-3.101 2.09-4.575 5.371-4.441h7.715c1.367.172 2.461.746 2.871 2.01 0 .019.02.057.02.076l.84 3.485h4.433l.684-.192c.645-.325 1.055-1.014 1.152-2.374v-.057c.117-.88.196-1.666.274-2.393l.117-1.513H9.301v17.27c0 .46 0 .919.02 1.34l.077.785h37.403c.117 0 .254.02.352.076l.078.02zm-31.407-4.384c-1.738 0-3.125-1.378-3.125-3.063 0-1.685 1.406-3.063 3.125-3.063s3.125 1.378 3.125 3.063c0 1.685-1.406 3.063-3.125 3.063zm0-1.8c.723 0 1.29-.574 1.29-1.263 0-.709-.587-1.264-1.29-1.264-.722 0-1.289.575-1.289 1.264 0 .69.567 1.264 1.29 1.264zm24.18-.306v-1.761h-1.308a.908.908 0 01-.918-.9c0-.498.41-.9.918-.9h1.308v-1.13h-2.5c-.43 0-.8-.287-.879-.689l-.996-4.116-.176-.306c-.273-.307-.879-.556-2.246-.46H26.762c-2.559-.096-3.496.785-3.535 2.661v5.974c.039 1.206.546 1.666 1.796 1.627h14.981zM6 19.703a.908.908 0 01-.918-.9V14.17c0-.498.41-.9.918-.9s.918.402.918.9v4.633c0 .498-.41.9-.918.9zm9.824-.306c-1.738 0-3.125-1.379-3.125-3.063 0-1.685 1.406-3.064 3.125-3.064s3.125 1.379 3.125 3.064c0 1.684-1.406 3.063-3.125 3.063zm0-1.8c.723 0 1.29-.574 1.29-1.263 0-.709-.587-1.283-1.29-1.283a1.28 1.28 0 00-1.289 1.283c0 .689.567 1.263 1.29 1.263zM44.926 9.5l.02-.843a37.922 37.922 0 00-.137-2.374c-.059-1.55-1.856-2.374-3.34-2.297h-.059l-26.64.038-1.133.153c-2.207.44-3.75 1.685-4.2 4.538l-.078.785h35.567zM15.004 8.235a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c0 .517-.41.919-.918.919zm4.121 0a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c-.02.517-.43.919-.918.919zm4.102 0a.908.908 0 01-.918-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c0 .517-.41.919-.918.919zm4.12 0a.908.908 0 01-.917-.9V6.186c0-.497.41-.9.918-.9s.918.403.918.9v1.13c-.02.517-.43.919-.918.919z'
        />
      </svg>
    ),
    title: (
      <>
        FAST TAILORING
        <br />
        (5-7 BUSINESS DAYS)
      </>
    ),
    svgWrapperClassName: clsx('lg_px-[17px] lg_py-2'),
    className: clsx('bg-E7DED5 pt-[23px] lg_pt-[26px]'),
  },
  WebsiteEnv.isUnitedStates
    ? {
        svg: (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='63'
            height='36'
            fill='none'
            viewBox='0 0 63 36'
            className='h-auto w-[50px] lg_w-[62px]'
          >
            <g clipPath='url(#clip0_12170_29533)'>
              <path
                fill='#80583F'
                d='M9.449 2.334h17.997c.492 0 .89-.4.89-.896a.892.892 0 00-.89-.895H9.449c-.493 0-.89.4-.89.895 0 .496.397.896.89.896z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M9.449 2.334h17.997c.492 0 .89-.4.89-.896a.892.892 0 00-.89-.895H9.449c-.493 0-.89.4-.89.895 0 .496.397.896.89.896z'
              />
              <path
                fill='#80583F'
                d='M3.023 9.002h14.834c.493 0 .89-.4.89-.896a.892.892 0 00-.89-.895H3.023c-.493 0-.89.4-.89.895 0 .496.397.896.89.896z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M3.023 9.002h14.834c.493 0 .89-.4.89-.896a.892.892 0 00-.89-.895H3.023c-.493 0-.89.4-.89.895 0 .496.397.896.89.896z'
              />
              <path
                fill='#80583F'
                d='M16.864 20.54a.892.892 0 00-.89-.895H1.14c-.492 0-.89.4-.89.895s.398.895.89.895h14.834c.493 0 .89-.4.89-.895z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M16.864 20.54a.892.892 0 00-.89-.895H1.14c-.492 0-.89.4-.89.895s.398.895.89.895h14.834c.493 0 .89-.4.89-.895z'
              />
              <path
                fill='#80583F'
                d='M19.34 26.934a.892.892 0 00-.89-.895h-8.212c-.493 0-.89.4-.89.895 0 .496.397.896.89.896h8.206c.493 0 .896-.4.896-.895z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M19.34 26.934a.892.892 0 00-.89-.895h-8.212c-.493 0-.89.4-.89.895 0 .496.397.896.89.896h8.206c.493 0 .896-.4.896-.895z'
              />
              <path
                fill='#80583F'
                d='M10.238 13.133c-.493 0-.89.4-.89.895 0 .496.397.896.89.896h8.206c.493 0 .89-.4.89-.896a.892.892 0 00-.89-.895h-8.206z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M10.238 13.133c-.493 0-.89.4-.89.895 0 .496.397.896.89.896h8.206c.493 0 .89-.4.89-.896a.892.892 0 00-.89-.895h-8.206z'
              />
              <path
                fill='#80583F'
                d='M24.478 32.43h-11.37c-.492 0-.89.4-.89.895 0 .496.398.896.89.896h11.376a.897.897 0 00-.006-1.79z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M24.478 32.43h-11.37c-.492 0-.89.4-.89.895 0 .496.398.896.89.896h11.376a.897.897 0 00-.006-1.79z'
              />
              <path
                fill='#80583F'
                d='M41.778.5L22.055 7.007v22.667L42.277 35.5l20.471-5.773V6.995L41.778.5zm.012 1.88L58.75 7.634l-6.45 1.88-16.674-5.098L41.79 2.38zm.611 10.018L25.96 7.604l6.723-2.22 16.484 5.037-6.764 1.977zM23.835 8.852l17.676 5.151v19.42L23.835 28.33V8.852zM43.29 33.357V14.003l17.677-5.151v19.52l-17.677 4.985z'
              />
              <path
                fill='#000'
                fillOpacity='0.2'
                d='M41.778.5L22.055 7.007v22.667L42.277 35.5l20.471-5.773V6.995L41.778.5zm.012 1.88L58.75 7.634l-6.45 1.88-16.674-5.098L41.79 2.38zm.611 10.018L25.96 7.604l6.723-2.22 16.484 5.037-6.764 1.977zM23.835 8.852l17.676 5.151v19.42L23.835 28.33V8.852zM43.29 33.357V14.003l17.677-5.151v19.52l-17.677 4.985z'
              />
            </g>
            <defs>
              <clipPath id='clip0_12170_29533'>
                <path
                  fill='#fff'
                  d='M0 0H62.5V35H0z'
                  transform='translate(.25 .5)'
                />
              </clipPath>
            </defs>
          </svg>
        ),
        title: (
          <>
            Free SHIPPING
            <br />
            FOR ACCESSORIES
          </>
        ),
        svgWrapperClassName: clsx('lg_px-[14px] lg_py-2.5'),
        className: clsx('bg-E7DED5 pt-[24px] lg_pt-[26px]'),
      }
    : null,
].filter(Boolean);

export default Footer;
